<template>
  <div>
    <div class="include-exam-header">
      <div class="header-info">
        <div class="header-info-row header-info-labels">
          <span>DADOS DO PACIENTE</span>
        </div>
        <div class="header-info-row header-info-values">
          <div class="header-info-block">
            <span class="header-label">PACIENTE</span>
            <span class="header-value header-patient">{{ exam.patientName || '-' }}</span>
          </div>
          <div class="header-info-block">
            <span class="header-label">OS ÁLVARO</span>
            <span class="header-value header-os">{{ exam.orderId || '-' }}</span>
          </div>
          <div class="header-info-block">
            <span class="header-label">AMOSTRAS DISPONÍVEIS</span>
            <span class="header-value header-samples">{{ availableSamples.length }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Busca de exames -->
    <div class="exam-selection">
      <div class="exam-selection-label">
        <span>SELECIONAR EXAME</span>
      </div>
      <p
        v-if="newExamsList.length < 1"
        class="bold"
      >
        Pesquise o exame a ser incluído, selecione-o e clique em confirmar.
      </p>
      <p
        v-if="newExamsList.length >= 1"
        class="bold"
      >
        Exame selecionado. Agora clique em confirmar para tentar adicionar nas amostras
        disponíveis.
      </p>
      <div class="insert-exam-after-transferred">
        <div
          v-if="newExamsList.length < 1"
          class="form-container"
        >
          <md-input-container class="search">
            <search
              :fetch="searchExam"
              :min-chars="2"
              placeholder="Digite o nome ou código do exame que deseja adicionar.."
              class="search__input-container"
            />
          </md-input-container>
        </div>
        <p
          v-if="newExamsList.length == 0"
          class="search__message"
        >
          Nenhum exame novo adicionado.
        </p>
        <div
          v-else
          class="insert-exam-after-transferred__exams-container"
        >
          <div
            v-for="(item, index) in newExamsList"
            :key="item.componentUniqUid"
            :class="['search-results__exams', 'exam-card-num-' + index]"
            @click="selectExam(item)"
          >
            <component
              :is="examComponent[item.type]"
              :index="index"
              :item="item"
              :patient="patientData"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import notify from '@/api/notification'
import Search from '@/components/common/Search'
import CommonExam from '@/components/Exams/Create/CommonExam'
import AdditionalExam from '@/components/Exams/Create/AdditionalExam'
import CurveExam from '@/components/Exams/Create/CurveExam'
import PaternityExam from '@/components/Exams/Create/PaternityExam'
import LoadingExam from '@/components/Exams/LoadingExam'

export default {
  name: 'TraceabilityExamInclusion',
  components: {
    search: Search,
    'common-exam': CommonExam,
    'additional-exam': AdditionalExam,
    'curve-exam': CurveExam,
    'paternity-exam': PaternityExam,
    'loading-exam': LoadingExam,
  },
  props: {
    exam: {
      type: Object,
      default: () => ({}),
    },
    patient: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    examComponent: {
      LOADING: 'loading-exam',
      STANDARD: 'common-exam',
      ADDITIONAL: 'additional-exam',
      CURVE: 'curve-exam',
      PATERNITY: 'paternity-exam',
    },
    selectedSampleCode: null,
    sampleStatuses: {},
    isProcessing: false,
    currentSampleBeingProcessed: null,
  }),
  computed: {
    ...mapGetters(['newExamsList']),
    patientData() {
      return this.patient && Object.keys(this.patient).length > 0
        ? this.patient
        : {
            name: this.exam.patientName,
            orderId: this.exam.orderId,
          }
    },
    availableSamples() {
      return this.exam && this.exam.samples ? this.exam.samples : []
    },
    selectedSample() {
      if (this.selectedSampleCode) {
        return this.availableSamples.find(
          sample => sample.codeSample === this.selectedSampleCode
        )
      }
      return null
    },
    canStartProcess() {
      return this.newExamsList && this.newExamsList.length > 0
    },
  },
  watch: {
    newExamsList: function (newValue) {
      if (newValue.length > 0) {
        let examTemplate = this.newExamsList[0].type
        if (
          this.fobiddenExamsTemplates &&
          this.fobiddenExamsTemplates.includes(examTemplate)
        ) {
          this.clearExamList()
          notify({
            title: 'AVISO:',
            message: 'Não é possível adicionar o exame selecionado na amostra.',
          })
        }
      }
    },
  },
  methods: {
    ...mapActions(['clearExamList', 'searchExam']),
    selectExam(item) {
      this.$emit('exam-selected', item)
    },
    formatDate(dateStr) {
      const date = new Date(dateStr)
      return (
        date.toLocaleDateString('pt-BR') +
        ' às ' +
        date.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })
      )
    },
    getExamData() {
      if (this.newExamsList && this.newExamsList.length > 0) {
        const examData = this.newExamsList[0]
        return {
          ...examData,
          availableSamples: this.availableSamples,
          canStartProcess: this.canStartProcess,
        }
      }
      return null
    },
    resetSampleStatuses() {
      this.sampleStatuses = {}
      this.availableSamples.forEach(sample => {
        this.$set(this.sampleStatuses, sample.codeSample, 'pending')
      })
      this.currentSampleBeingProcessed = null
      this.isProcessing = false
    },
    setSampleStatus(sampleCode, status) {
      this.$set(this.sampleStatuses, sampleCode, status)
      if (status === 'processing') {
        this.currentSampleBeingProcessed = sampleCode
      } else if (this.currentSampleBeingProcessed === sampleCode) {
        this.currentSampleBeingProcessed = null
      }
    },
    startProcessing() {
      this.isProcessing = true
    },
    stopProcessing() {
      this.isProcessing = false
      this.currentSampleBeingProcessed = null
    },
    checkAndSelectSingleSample() {
      if (this.availableSamples.length === 1) {
        this.selectedSampleCode = this.availableSamples[0].codeSample
      }
    },
  },
}
</script>

<style lang="scss">
.include-exam-after-transferred {
  p {
    padding-bottom: 8px;
  }

  &-content {
    padding-top: 19px;
    font-size: 18px;
    letter-spacing: -0.2px;
    text-align: center;
    color: #303030;
  }

  .close-button {
    position: absolute;
    top: 10px;
    right: 32px;
  }

  .dialog-actions {
    width: 100%;
    height: 44px;
    margin-top: 37px;

    .md-button {
      width: 182px;
      height: 33px;
      margin: 6px 7px;
      font-weight: 400;
      letter-spacing: 0.5px;
    }
  }

  .insert-exam-after-transferred {
    #txtNewSampleQuantity {
      pointer-events: none;
      color: #a1a1a1;
      cursor: not-allowed;
    }

    &__exams-container {
      padding: 10px;
      background-color: #f7f7f7;
      border-radius: 8px;
    }

    .exam-curve__container .exam-curve__curves__item {
      width: 8%;
    }

    .md-input-container {
      &.search {
        margin: 0 0 20px;
        padding: 0;
        min-height: 39px;

        &:after {
          display: none;
        }

        .search {
          &__label {
            position: relative;
            display: flex;
            align-items: center;
            float: left;
            width: 105px;
            top: inherit;
            left: inherit;
            font-size: 13px;
            font-weight: 500;
            letter-spacing: 1.1px;
            color: #727272;
          }

          &__input-container {
            position: relative;
            display: block;
            width: 100%;
          }
        }
      }
    }

    .search {
      &__message {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        padding: 10px 0;
        height: 110px;
        font-size: 15px;
        line-height: 1.5;
        color: #969696;
      }

      &-results__exams {
        margin: 22px 0 20px;

        .multiselect {
          &__content-wrapper {
            max-height: 150px !important;
          }
        }
      }
    }

    .card-form__container {
      transition:
        min-height 600ms,
        opacity 600ms;
      opacity: 1;
      min-height: 237px;
      border-radius: 6px;

      .collapsed__list__item__edit-button {
        position: absolute;
        right: 0;
        margin-top: 3px;

        & > .md-icon:not(.md-icon-delete) {
          position: static;
          margin: 0;
          line-height: 16px;
          color: #c2c2c2;
        }
      }

      .card-form__delete-button {
        position: absolute;
        top: 5px;
        right: 0px;
        color: #c2c2c2;
      }

      &.card-form--collapsed {
        transition:
          min-height 600ms,
          opacity 600ms;
        min-height: 90px;

        &.exam__container {
          .collapsed__list__item__edit-button {
            position: absolute;
            right: 37px;
            margin-top: 3px;

            & > .md-icon:not(.md-icon-delete) {
              position: static;
              margin: 0;
              line-height: 16px;
              color: #c2c2c2;
            }
          }

          .collapsed__list__item__delete-button {
            position: absolute;
            margin-top: 3px;
            right: 0;

            & > .md-icon {
              top: -4px;
            }
          }
        }

        .submit-button,
        .form-container {
          animation-duration: 700ms;
          animation-name: fadeout;
          display: none;
        }

        .collapsed-container {
          opacity: 1;
          display: flex;
          animation-name: fadein;
          animation-duration: 700ms;

          .collapsed__item {
            .md-input-container {
              flex: 1;
              flex-direction: column;
              margin: 0 15px 0;
              padding-top: 0;

              &:after {
                height: 0;
              }
            }

            h3 {
              font-size: 12px;
              color: #858585;
              font-weight: normal;
              white-space: nowrap;
            }

            p {
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              width: 90%;
              color: #303030;
              font-size: 16px;
            }

            input {
              font-size: 16px;
            }
          }
        }
      }

      .form-container {
        animation-name: fadein;
        animation-duration: 700ms;
        display: flex;
        flex-wrap: wrap;

        .exam-item__details-anchor {
          flex-shrink: 1;
        }

        .md-switch-label {
          font-size: 14px;
        }

        .required-fields-label {
          position: absolute;
          right: 5px;
          top: -30px;
          font-size: 12px;
          color: #a80009;
        }

        .tab-label {
          position: absolute;
          right: 180px;
          top: -30px;
          font-size: 12px;
          color: #000;

          strong {
            font-weight: 700;
          }
        }

        .md-layout {
          .md-input-container {
            margin: 0 0 17px;
          }
        }

        .md-input-container,
        .md-input-container.md-input-focused {
          .md-icon {
            color: #c2c2c2;
          }
        }
      }

      .collapsed-container {
        animation-name: fadeout;
        animation-duration: 700ms;
        display: none;
      }
    }

    .IE {
      .insert-exam-after-transferred {
        .search-results__exams {
          .exam__container {
            .exam-item__details.md-flex-25 {
              min-width: 17%;
              max-width: 18.3%;
            }
          }
        }
      }

      @media only screen and (max-width: 1024px) {
        .insert-exam-after-transferred {
          .search-results__exams {
            .paternity-exam {
              .collapsed__item {
                padding: 0;
              }

              .md-flex-35 {
                min-width: 10%;

                .md-theme-default {
                  width: 240px;
                  margin-right: 0;
                }
              }
            }

            .exam__container {
              .exam-item__details.md-flex-25 {
                min-width: 17%;
                max-width: 21.7%;
              }
            }
          }
        }

        .orders-new_container
          .card-form__container.card-form--collapsed
          .collapsed-container
          .collapsed__item
          p {
          width: 100%;
        }
      }
    }
  }
}

@media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {
  .insert-exam-after-transferred .search .search-container .search__input {
    height: 200% !important;
  }
}

.include-exam-header {
  border-bottom: 1px solid #d1d1d1;
  margin-bottom: 24px;
  padding-bottom: 16px;

  .header-title {
    font-size: 20px;
    font-weight: 400;
    color: #303030;
    margin-bottom: 4px;
  }

  .header-info {
    .header-info-row {
      display: flex;
      align-items: flex-start;
      gap: 40px;
      margin-bottom: 2px;

      &.header-info-labels {
        font-size: 13px;
        font-weight: 600;
        color: #8d3c8a;
        letter-spacing: 0.5px;
        margin-bottom: 0;
      }

      &.header-info-values {
        margin-top: 6px;
        margin-bottom: 0;
      }
    }

    .header-info-block {
      display: flex;
      flex-direction: column;
      min-width: 140px;
    }

    .header-label {
      font-size: 12px;
      color: #969696;
      text-transform: uppercase;
      font-weight: 600;
      margin-bottom: 2px;
      letter-spacing: 0.5px;
    }

    .header-value {
      font-size: 16px;
      color: #303030;
      font-weight: 400;
      margin-right: 0;
      line-height: 1.2;
    }

    .header-patient {
      color: #e47c2c;
      font-weight: 700;
      letter-spacing: 0.2px;
    }

    .header-os {
      color: #8d3c8a;
      font-weight: 700;
      letter-spacing: 0.2px;
    }

    .header-samples {
      color: #28a745;
      font-weight: 700;
      letter-spacing: 0.2px;
      font-size: 18px;
    }
  }
}

.bold {
  font-weight: 800;
  color: #303030;
}

.exam-selection {
  margin-bottom: 24px;
}

.exam-selection-label {
  font-size: 13px;
  font-weight: 600;
  color: #8d3c8a;
  letter-spacing: 0.5px;
  margin-bottom: 12px;
}
</style>
